// mouse.js
// #ifdef APP-PLUS
import { useStore } from 'vuex';
import { reactive } from 'vue';
const _get = require( 'lodash/get' );
const _replace = require( 'lodash/replace' );
// #endif
export function useLang( langname ) {
// #ifdef APP-PLUS
	const _store = require('@/store').default;
	const store = useStore() || _store;
	let lang = reactive({});
	function $t( val ,attr) {
		let txt = _get( store.state.i18n[ langname ], val, val );
		if ( attr && txt ){
			Object.keys( attr ).forEach(( key ) => {
				attr[ key.toLowerCase() ] = attr[ key ];
			});
			txt.match( /{(.*?)}/g ) && txt.match( /{(.*?)}/g ).forEach(( key ) => {
				txt = _replace( txt, key, attr[ key.toLowerCase().replace( /^{+|}+$/g, '' ) ]);
			});
		}
		return txt || '';
	}
	function $getLang( val ) {
    lang = _get(store, `state.i18n[${val}]`) || {};
	}

	// 获取语言包
	if ( langname ) {
		$getLang( langname );
	}

	// 语言转换
	function $doLang( lg ) {
		if (
			!lg ||
			lg.startsWith( 'zh_CN' ) ||
			lg === 'zh' ||
			lg.startsWith( 'zh-' ) ||
			lg.startsWith( 'zh,' ) ||
			lg.startsWith( 'zh_' ) ||
			lg === 'cn'
		) {
			return 'zh-cn';
		}
		if (
			lg.startsWith( 'en_' ) ||
			lg.startsWith( 'en,' ) ||
			lg.startsWith( 'en-' ) ||
			lg === 'en'
		) {
			return 'en-us';
		}
		if (
			lg.startsWith( 'ja_JP' ) ||
			lg.startsWith( 'ja,' ) ||
			lg.startsWith( 'ja-' ) ||
			lg.startsWith( 'ja_' ) ||
			lg === 'ja'
		) {
			return 'ja-jp';
		}
		return lg;
	}
	// 通过返回值暴露所管理的状态
  // #endif
  if(typeof lang !== 'undefined'){
    return { lang, $t, $getLang, $doLang };
  } else {
    return { lang: {}, $t: window.i18n.t };
  }
}

export function useIndependentLang( langname = '@shining3d/xl-login', usedLang = 'en_US' ) {
// #ifdef APP-PLUS
	let lang = reactive({});

	const etcdConfigLangKey = getEtcdConfigLangKey( usedLang );

	function $t( val, attr ) {
		let txt = _get( window, `app.allI18n.${etcdConfigLangKey}.${langname}.${val}`, val );
		if ( attr ){
			Object.keys( attr ).forEach(( key ) => {
				attr[ key.toLowerCase() ] = attr[ key ];
			});
			
			txt.match( /{(.*?)}/g ) && txt.match( /{(.*?)}/g ).forEach(( key ) => {
				txt = _replace( txt, key, attr[ key.toLowerCase().replace( /^{+|}+$/g, '' ) ]);
			});
		}
		return txt || '';
	}
	
	function $getLang( langname ) {
		lang = _get( window, `app.allI18n.${etcdConfigLangKey}.${langname}`, {} );
	}

	const doLang = doLangFunction;

	// 获取语言包
	if ( langname ) {
		$getLang( langname );
	}

	// 通过返回值暴露所管理的状态
  // #endif
  if(typeof lang !== 'undefined'){
    return { lang, $t, $getLang, doLang };
  } else {
    return { lang: {}, $t: window.i18n.t };
  }
}

// 语言转换
function doLangFunction( lg ) {
	if (
		!lg ||
		lg.startsWith( 'zh_CN' ) ||
		lg === 'zh' ||
		lg.startsWith( 'zh-' ) ||
		lg.startsWith( 'zh,' ) ||
		lg.startsWith( 'zh_' ) ||
		lg === 'cn'
	) {
		return 'zh-cn';
	}
	if (
		lg.startsWith( 'en_' ) ||
		lg.startsWith( 'en,' ) ||
		lg.startsWith( 'en-' ) ||
		lg === 'en'
	) {
		return 'en-us';
	}
	if (
		lg.startsWith( 'ja_JP' ) ||
		lg.startsWith( 'ja,' ) ||
		lg.startsWith( 'ja-' ) ||
		lg.startsWith( 'ja_' ) ||
		lg === 'ja'
	) {
		return 'ja-jp';
	}
	return lg;
}

function getEtcdConfigLangKey( curLang ) {
	const lang = doLangFunction( curLang );
	const queryLangArr = lang.split( '-' );
	const l = queryLangArr[ 0 ];
	const r = queryLangArr[ 1 ].toLocaleUpperCase();
	const etcdConfigLangKey = l + '_' + r;
	return etcdConfigLangKey;
};